import React from 'react';

/**
 * What a job lane shows while its source is still loading.
 *
 * <p>Three skeleton cards the shape of a job card, pulsing. Extracted because every
 * lane — the four board columns, the split view's sidebar, the planner's active list
 * — used to show either nothing or "No jobs" for the second or two the page took to
 * arrive, and "No jobs" on a board with forty queued cars is a claim, not a wait.
 *
 * <p>🔑 Which lane is loading is the caller's decision, from the SOURCE that feeds it:
 * the Queued column waits on the queued page, the other three on the month query. A
 * single flag for the whole board would blank three columns while the fourth pages.
 *
 * Presentational only.
 *
 * @param {number} [cards=3]
 * @param {string} [label='Loading jobs'] the accessible name, for screen readers and tests
 */
export default function LaneLoading({ cards = 3, label = 'Loading jobs', className = '' }) {
    return (
        <div role="status" aria-label={label} data-testid="lane-loading" className={`space-y-3 ${className}`}>
            {Array.from({ length: cards }, (_, i) => (
                <div key={i} className="p-3 rounded-xl border-l-4 border-l-gray-200 bg-white shadow-sm animate-pulse">
                    <div className="flex items-center justify-between mb-3">
                        <div className="h-3.5 w-28 rounded bg-gray-200" />
                        <div className="h-3.5 w-6 rounded bg-gray-100" />
                    </div>
                    <div className="h-3 w-40 rounded bg-gray-100 mb-2" />
                    <div className="h-6 w-full rounded-lg bg-gray-100" />
                </div>
            ))}
        </div>
    );
}
